import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { withRouter } from 'react-router';
import MetricTable from './MetricTable';
import { Modal, Spin, Affix } from 'antd';
import MetricBarGraph from './MetricBarGraph';
import MonthService from 'components/commons/MonthService';
import Titlebar from 'components/layouts/Titlebar';
import { MetricsCrudService } from 'utils/MetricsCrudService';
import { GoalCrudService } from 'utils/GoalCrudService';
import * as Messages from 'constants/Messages';
import MediaQuery from 'react-responsive';
import { translate } from 'react-i18next';
import _ from 'lodash';

const metricsMap = {
    [Messages.REVENUES]: Messages.REVENUES_TITLE,
    [Messages.IMPRESSIONS]: Messages.IMPRESSIONS_TITLE,
    [Messages.TRAFFIC]: Messages.TRAFFIC_TITLE,
    [Messages.VISITORS]: Messages.VISITORS_TITLE,
    [Messages.OPTIN]: Messages.OPTIN_TITLE,
    [Messages.CLOSE_RATE]: Messages.CLOSE_RATE_TITLE,
}

const fixesMap = {
    [Messages.REVENUES]: { prefix: '', suffix: '', sum: 'sum' },
    [Messages.IMPRESSIONS]: { prefix: '', suffix: ' Impressions', sum: 'sum' },
    [Messages.TRAFFIC]: { prefix: '', suffix: '%', sum: 'mean' },
    [Messages.VISITORS]: { prefix: '', suffix: '', sum: 'sum' },
    [Messages.OPTIN]: { prefix: '', suffix: '%', sum: 'mean' },
    [Messages.CLOSE_RATE]: { prefix: '', suffix: '%', sum: 'mean' },
}


class MetricForm extends Component {
    constructor(props) {
        super(props);
        this.crudService = new MetricsCrudService();
        this.goalCrudService = new GoalCrudService();
        this.state = {
            isEditable: props.isEditable,
            loading: true,
            view: props.view,
            metrics: [],
            quarterlyMetrics: [],
            goals: props.goals,
            visible: true,
            type: props.type || props.match.params.type,
            currency: props.currency
        }
    }

    async componentWillReceiveProps(nextProps) {
        this.updateMetrics(nextProps.match.params.goalId, nextProps.match.params.type);
    }

    async componentWillMount() {
        this.updateMetrics(this.props.match.params.goalId, this.props.match.params.type);
    }

    async updateMetrics(goalId, type) {
        const {t} = this.props;
        let currency = '';
        let metrics = [];
        let quarterlyMetrics = [];
        let metricTitle = t(metricsMap[type] || this.props.metricTitle);
        if (type) {
            metrics = await this.crudService.listByGoalIdAndType(goalId, type);
        } else {
            const goal = await this.goalCrudService.get(goalId);
            currency = goal.currency;
            metrics = await this.crudService.listRevenuesByGoal(goal);
        }

        quarterlyMetrics = MonthService.getQuarterlyMetricValues(metrics);
        this.setState({ metrics, quarterlyMetrics, loading: false, metricTitle, type: type || this.props.type, currency: currency });
    }

    render() {
        const metrics = this.state.metrics;
        const quarterlyMetrics = this.state.quarterlyMetrics;
        return (
            <Spin spinning={this.state.loading}>
            <div ref={(topDiv) => this.topDiv = topDiv}>
                <MediaQuery query="(min-width: 768px)">
                    <Titlebar title={this.state.metricTitle} description={this.props.t('dashboard.description')}/>
                </MediaQuery>
                <MediaQuery query="(max-width: 768px)">
                      <Affix offsetTop={64}>
                          <div className="content-title-header">
                              <h1>{this.state.metricTitle}</h1>
                          </div>
                      </Affix>
                </MediaQuery>
                <Row>
                    <Col md={12}>
                        <MetricBarGraph metrics={metrics} ref="metricBarGraph" {...fixesMap[this.state.type]} prefix={this.state.currency}/>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <MetricTable isEditable={this.state.isEditable} dateFormat="MMM-YYYY" metrics={metrics} onBlur={this.updateMetricValues.bind(this)}/>
                    </Col>
                    <Col md={6}>
                        <MetricTable isEditable={false} dateFormat="[Q]Q (YYYY)"  metrics={quarterlyMetrics}/>
                    </Col>
                </Row>
            </div>
            </Spin>
        );
    }

    async updateMetricValues(metricValues) {
        this.state.metrics = metricValues;
        const isSuccessfull = this.crudService.updateAll(metricValues);
        this.refs.metricBarGraph.setState({ metricValues: metricValues });
        this.setState({ metrics: this.state.metrics });
    }
}

export default translate('translations')(withRouter(MetricForm));


// WEBPACK FOOTER //
// ./src/components/forecasts/MetricForm.js